import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeacherIndexViewComponent } from './teacher-index-view.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [TeacherIndexViewComponent],
  imports: [CommonModule, Ng2SmartTableModule],
  exports: [TeacherIndexViewComponent],
})
export class TeacherIndexViewModule {}
